(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .service('fileTypeService', fileTypeService);

    function fileTypeService() {
        this.mergeHeifHeic = function(typesArray) {
            if (!Array.isArray(typesArray)) return [];
            var merged = typesArray.filter(function(type) {
                return type !== 'heif' && type !== 'heic';
            });
            if (typesArray.includes('heif') || typesArray.includes('heic')) {
                merged.push('heif/heic');
            }
            return merged;
        };

        this.splitHeifHeic = function(typesArray) {
            if (!Array.isArray(typesArray)) return [];
            var split = typesArray.reduce(function(arr, type) {
                if (type === 'heif/heic') {
                    arr.push('heif', 'heic');
                } else {
                    arr.push(type);
                }
                return arr;
            }, []);
            return split;
        };
    }
})();
